import * as React from 'react';
import Icon from '../../../widgets/Icons';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { onboardingSelector } from '../../../reducers/onboarding';
import { Link } from 'react-router-dom';
import { ROUTE_PATH } from '../../../constants';

const Header = styled.h1`
  color: #34618a;
  margin-bottom: 15px;
`;

const Item = styled.div`
  margin-bottom: 10px;
`;

Item.displayName = 'Item';

export const OnboardingCompletedView: React.FunctionComponent = () => {
  const hasCloudConfig = useSelector(
    onboardingSelector.hasPurchasedCloudSensors,
  );

  return (
    <div className="m-3">
      <div className="d-flex">
        <div>
          <Header>Technical Kickoff Complete</Header>
          <p>
            All of your technical details are now submitted and reviewed with
            your Onboarding Team.
          </p>
        </div>
        <div className="m-2">
          <Icon.ShieldCheck size={99} style={{ fill: '#24628F' }} />
        </div>
      </div>

      <Item>
        <Icon.CheckCircle className="ob-checklist-checkmark" />
        <label>Contacts</label>
      </Item>
      <Item>
        <Icon.CheckCircle className="ob-checklist-checkmark" />
        <label>Site Configuration</label>
      </Item>
      {hasCloudConfig && (
        <Item data-cy="cloud-config">
          <Icon.CheckCircle className="ob-checklist-checkmark" />
          <label>Cloud Configuration</label>
        </Item>
      )}
      <Item>
        <Icon.CheckCircle className="ob-checklist-checkmark" />
        <label>External Vulnerabilities</label>
      </Item>
      <p className="pt-2">
        You will receive instructions and actions items to continue the
        onboarding process. Please communicate with your team if you have any
        questions or would like further assistance. Once onboarding is complete,
        you will meet your Concierge Security Team (CST) who will assist you
        with your ongoing needs.
        <br />
        <br />
        <br />
        Please{' '}
        <Link to={ROUTE_PATH.CONTACT}> contact your Onboarding Team</Link> if
        you have questions.
      </p>
    </div>
  );
};
